var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionCheckMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 125,
    viewBox: "0 0 130 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2647 61.8924C19.1236 45.2209 34.8782 31.687 43.7731 27.0039C67.0659 18.5745 102.344 53.9313 107.771 63.5315C113.199 73.1317 97.1428 99.5907 80.4082 102.401C63.6737 105.21 37.4411 82.7318 27.2647 61.8924Z",
    fill: "#F4FCF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4007 60.2547L66.0267 74.4311L57.6436 66.3371L60.319 63.5661L65.8989 68.9535L76.5989 57.6115L79.4007 60.2547Z",
    fill: "#4DC783"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5056 95.1313L70.8853 116.877H66.1259L68.5056 95.1313Z",
    fill: "#FFEAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5061 25.7726L66.2906 6.44313L70.7217 6.44313L68.5061 25.7726Z",
    fill: "#87D9AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3631 94.0503L58.365 107.136L55.5507 106.382L60.3631 94.0503Z",
    fill: "#87D9AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9263 34.0567L78.6433 16.2626L82.4703 17.288L75.9263 34.0567Z",
    fill: "#C3ECD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6736 95.5101L41.288 114.63L37.3084 112.332L49.6736 95.5101Z",
    fill: "#87D9AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5421 28.3415L95.7592 11.8862L99.1842 13.8637L88.5421 28.3415Z",
    fill: "#FFEAAA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.732 77.0813L33.5893 86.0069L31.9308 83.1343L45.732 77.0813Z",
    fill: "#87D9AC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.92 44.9961L114.247 35.1996L116.068 38.3525L100.92 44.9961Z",
    fill: "#C3ECD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1737 73.2677L17.0684 81.1138L15.839 76.5254L37.1737 73.2677Z",
    fill: "#FFEAAA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6962 56.3546L106.727 51.2692L107.524 54.2431L93.6962 56.3546Z",
    fill: "#87D9AC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.548 56.4051L18.5906 53.6631L19.6255 49.801L36.548 56.4051Z",
    fill: "#87D9AC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1072 72.0219L110.926 74.132L110.13 77.104L97.1072 72.0219Z",
    fill: "#C3ECD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1917 50.9129L32.2462 45.2351L33.8019 42.5406L45.1917 50.9129Z",
    fill: "#C3ECD5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5386 80.8371L119.365 89.5325L116.982 93.6592L99.5386 80.8371Z",
    fill: "#87D9AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 64.1472L7.39048 66.5269L7.39048 61.7676L29.5625 64.1472Z",
    fill: "#C3ECD5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.385 63.7681L122.846 61.3884L122.846 66.1477L101.385 63.7681Z",
    fill: "#FFEAAA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8883 87.7692L35.1451 101.188L32.4698 98.5124L45.8883 87.7692Z",
    fill: "#C3ECD5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6181 44.9792L99.8312 29.7248L102.872 32.7662L87.6181 44.9792Z",
    fill: "#87D9AC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7012 82.016L100.529 92.2863L97.9715 94.8438L87.7012 82.016Z",
    fill: "#FFEAAA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2975 37.5598L27.5753 25.7728L30.5105 22.8375L42.2975 37.5598Z",
    fill: "#FFEAAA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9843 97.0244L97.6121 110.122L94.5135 111.911L87.9843 97.0244Z",
    fill: "#87D9AC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5034 36.0505L43.8131 24.2281L46.61 22.6133L52.5034 36.0505Z",
    fill: "#C3ECD5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7153 90.9798L82.1956 107.585L78.4059 108.601L75.7153 90.9798Z",
    fill: "#C3ECD5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7512 33.2749L53.2692 14.1026L57.6446 12.9302L60.7512 33.2749Z",
    fill: "#87D9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionCheckMark);
export default __webpack_public_path__ + "static/media/subscription_check_mark.035126285cff7f8a1679dcc28c9875f1.svg";
export { ForwardRef as ReactComponent };